export const URL_BACKEND = process.env.NEXT_PUBLIC_BACKEND_URL ?? "";
